import { initNewRelicBrowser } from '../libs/newrelic';
import type { NewRelicBrowser } from '../libs/newrelic';
import { createErrorHandler } from '../libs/newrelic/utils/error-filter';
import type { App, ComponentPublicInstance } from 'vue';

export default defineNuxtPlugin(
  async ({
    vueApp,
    $router,
    $config: {
      public: {
        newRelicLicenseKey,
        newRelicApplicationId,
        serverEnv,
        newRelicEnabled,
        newRelicReleaseVersion,
        newRelicReleaseName,
      },
    },
  }) => {
    const newrelic = await initNewRelicBrowser({
      licenseKey: newRelicLicenseKey,
      applicationId: newRelicApplicationId,
      enabled: newRelicEnabled,
      environment: serverEnv,
      ajaxDenyList: [
        // local
        'localhost',
        '127.0.0.1',
        // Facebook flakiness
        'graph.facebook.com',
        // Facebook blocked
        'connect.facebook.net/en_US/all.js',
      ],
    });

    if (newrelic) {
      newrelic.setErrorHandler(createErrorHandler());
    }

    // Setup Vue error handler
    if (newrelic && vueApp) {
      setupVueErrorHandler(newrelic, vueApp);
    }

    if (newrelic) {
      if (newRelicReleaseVersion) {
        newrelic.setApplicationVersion(newRelicReleaseVersion);

        // NOTE: ソースマップアップロード時に指定したreleaseName, releaseVersionと合わせる必要がある
        // ref: https://ceblog.mediba.jp/post/664462603059445760/newrelic-%E3%83%96%E3%83%A9%E3%82%A6%E3%82%B6%E3%83%A2%E3%83%8B%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%B0%E3%81%AE%E3%82%BD%E3%83%BC%E3%82%B9%E3%83%9E%E3%83%83%E3%83%97%E3%81%A7%E8%89%B2%E3%80%85%E3%83%8F%E3%83%9E%E3%81%A3%E3%81%9F%E8%A9%B1
        newrelic.addRelease(newRelicReleaseName, newRelicReleaseVersion);
      }
    }

    // Setup router tracking
    if (newrelic && $router) {
      const router = $router as {
        afterEach: (hook: (to: unknown, from: unknown) => void) => void;
      };
      router.afterEach((to: unknown) => {
        const route = to as { name?: string; path?: string };
        const routeName = route.name || route.path || 'Unknown';
        newrelic.setPageViewName(String(routeName));
      });
    }

    return {
      provide: {
        newrelic,
      },
    };
  }
);

function setupVueErrorHandler(agent: NewRelicBrowser, app: App): void {
  app.config.errorHandler = (
    error: unknown,
    instance: ComponentPublicInstance | null,
    info: string
  ) => {
    const attributes = {
      component: instance?.$options?.name || 'Unknown',
      errorInfo: info,
    };
    agent.noticeError(error, attributes);
  };
}
